import { NzRateModule } from 'ng-zorro-antd/rate';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgZorroIconModule } from "src/app/modules/nz-icon-antd.module";
import { NgZorroAntdModule } from "src/app/modules/nz-zorro-antd.module";
import { TranslateModule } from "@ngx-translate/core";
import { InputFieldModule } from "src/app/shared/input-field/input-field.module";
import { SelectorModule } from "src/app/shared/selector/selector.module";
import { ValidationErrorsModule } from "src/app/shared/validation-errors/validation-errors.module";
import { AddTenderProductModule } from "./add-tender-product/add-tender-product.module";
import { GeneralSettingsComponent } from "./general-settings/general-settings.component";
import { RolesComponent } from "./roles/roles.component";
import { UsersComponent } from "./users/users.component";
import { SubOrganisationsComponent } from "./sub-organisations/sub-organisations.component";
import { DangerZoneComponent } from "./danger-zone/danger-zone.component";
import { ProductDetailsComponent } from "./product-details/product-details.component";
import { UserRoleModule } from "src/app/directives/user-role/user-role.module";
import { SortPipeModule } from "src/app/pipes/sort/sort.module";
import { UsersListComponent } from "./users-list/users-list.component";
import { TextAreaFieldModule } from "src/app/shared/text-area-field/text-area-field.module";
import { NzPaginationModule } from "ng-zorro-antd/pagination";
import { NzAlertModule } from "ng-zorro-antd/alert";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzCommentModule } from "ng-zorro-antd/comment";
import { NzAvatarModule } from "ng-zorro-antd/avatar";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { CommentProductDetailsComponent } from "./comment/comment-product-details.component";
import { NzDrawerModule } from "ng-zorro-antd/drawer";
import { FileSizeModule } from "src/app/pipes/fileSize/file-size.module";
import { NzPopconfirmModule } from "ng-zorro-antd/popconfirm";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { ImageWithLoadingComponent } from "./image-with-loading/image-with-loading.component";
import { SubscriptionModalModule } from "./subscription-modal/subscription-modal.module";
import { NzProgressModule } from "ng-zorro-antd/progress";
import { NzDescriptionsModule } from "ng-zorro-antd/descriptions";
import { InfoFieldComponent } from "./info-field/info-field.component";
import { BreadCrumbComponent } from './bread-crumb/bread-crumb.component';
import { RouterModule } from '@angular/router';
import { OrganizationProfileModalComponent } from './organization-profile-modal/organization-profile-modal.component';
import { RateSupplierModalComponent } from './rate-supplier-modal/rate-supplier-modal.component';
import { AttachmentModalModule } from './attachment-modal/attachment-modal.module';
import { AllowEditQuotationComponent } from './allow-edit-quotation/allow-edit-quotation.component';

@NgModule({
	declarations: [
		GeneralSettingsComponent,
		RolesComponent,
		UsersComponent,
		SubOrganisationsComponent,
		DangerZoneComponent,
		ProductDetailsComponent,
		UsersListComponent,
		CommentProductDetailsComponent,
		ImageWithLoadingComponent,
		BreadCrumbComponent,
		InfoFieldComponent,
		OrganizationProfileModalComponent,
		RateSupplierModalComponent,
		AllowEditQuotationComponent
	],
	imports: [
		CommonModule,
		NgZorroIconModule,
		NgZorroAntdModule,
		FormsModule,
		TranslateModule,
		ReactiveFormsModule,
		InputFieldModule,
		SelectorModule,
		ValidationErrorsModule,
		AddTenderProductModule,
		UserRoleModule,
		SortPipeModule,
		TextAreaFieldModule,
		NzAlertModule,
		NzModalModule,
		NzCommentModule,
		NzAvatarModule,
		NzDividerModule,
		NzDrawerModule,
		FileSizeModule,
		NzPopconfirmModule,
		SubscriptionModalModule,
		NzProgressModule,
		NzDescriptionsModule,
		RouterModule,
		NzRateModule,
		AttachmentModalModule
	],
	exports: [
		CommonModule,
		NgZorroIconModule,
		NgZorroAntdModule,
		FormsModule,
		TranslateModule,
		ReactiveFormsModule,
		InputFieldModule,
		SelectorModule,
		ValidationErrorsModule,
		AddTenderProductModule,
		GeneralSettingsComponent,
		RolesComponent,
		UsersComponent,
		SubOrganisationsComponent,
		DangerZoneComponent,
		UserRoleModule,
		SortPipeModule,
		TextAreaFieldModule,
		NzPaginationModule,
		NzAlertModule,
		NzModalModule,
		NzCommentModule,
		NzAvatarModule,
		NzDividerModule,
		CommentProductDetailsComponent,
		NzDrawerModule,
		FileSizeModule,
		NzPopconfirmModule,
		NzSpinModule,
		ImageWithLoadingComponent,
		SubscriptionModalModule,
		NzProgressModule,
		NzDescriptionsModule,
		BreadCrumbComponent,
		InfoFieldComponent,
		NzRateModule,
		AllowEditQuotationComponent
	]
} )
export class SharedModule { }
